import { render } from "./CLICommands.vue?vue&type=template&id=46c7458c&scoped=true"
import script from "./CLICommands.vue?vue&type=script&lang=js"
export * from "./CLICommands.vue?vue&type=script&lang=js"

import "./CLICommands.vue?vue&type=style&index=0&id=46c7458c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c7458c"]])

export default __exports__